
import Vue from 'vue';

export default Vue.extend({
	name: 'DownloadExcelButton',
	props: {
		downloadFunc: { type: Function },
		fileName: { type: String },
		buttonColor: { type: String, default: 'primary' },
	},
	methods: {
		async getFile() {
			const blob = await this.downloadFunc();
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.download = this.fileName;
			link.click();
			URL.revokeObjectURL(link.href);
		},
	},
});
